// extracted by mini-css-extract-plugin
export default {"collections-list":"collections-list--xcF8c","collections-list__heading":"collections-list__heading--XMrpA","collections-list__item":"collections-list__item--f6DC5"};